import PropTypes from 'prop-types';
import FJHeadshotGeneratorStepper from './FJHeadshotGeneratorStepper';
import FJHeadshotHistoryContainer from '../container/FJHeadshotHistoryContainer';
import FJHeadshotPreviewContainer from '../container/FJHeadshotPreviewContainer';

import styles from './FJHeadshotGeneratorRight.module.less';

const FJHeadshotGeneratorRight = ({ currentStepIndex, selectedCategory, onPrevious, tabIndex }) => {
    return (
        <div className={styles.app_right}>
            <FJHeadshotGeneratorStepper
                currentStepIndex={currentStepIndex}
                selectedCategory={selectedCategory}
                onPrevious={onPrevious}
                active={tabIndex === 0}
            />
            <FJHeadshotHistoryContainer active={tabIndex === 1} />
            <FJHeadshotPreviewContainer />
        </div>
    );
};

FJHeadshotGeneratorRight.propTypes = {
    currentStepIndex: PropTypes.number,
    selectedCategory: PropTypes.string,
    onPrevious: PropTypes.func,
    tabIndex: PropTypes.number,
};

export default FJHeadshotGeneratorRight;
